
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 7 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"3.5","cy":"3.5","r":"3.25","stroke":"#1B4332","stroke-width":".5"}}),_c('path',{attrs:{"d":"M5.908 2.087A.284.284 0 005.706 2a.277.277 0 00-.202.087l-2.12 2.19-.891-.922a.29.29 0 00-.207-.084.284.284 0 00-.204.091.301.301 0 00-.082.214.308.308 0 00.089.21l1.093 1.127A.284.284 0 003.384 5a.277.277 0 00.202-.087l2.322-2.395A.294.294 0 006 2.303a.301.301 0 00-.092-.216z","fill":"#1B4332"}})])
          )
        }
      }
    